module.exports = __webpack_public_path__ + "img/img5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img5.jpg
// module id = 1298
// module chunks = 0